import { render, staticRenderFns } from "./WidgetBuilder.vue?vue&type=template&id=0c69520a&scoped=true&"
import script from "./WidgetBuilder.vue?vue&type=script&lang=js&"
export * from "./WidgetBuilder.vue?vue&type=script&lang=js&"
import style0 from "./WidgetBuilder.vue?vue&type=style&index=0&id=0c69520a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c69520a",
  null
  
)

export default component.exports